import React, {Component} from 'react';

class Reload extends Component {

    componentWillMount() {
        window.history.go(-1);
    }

    // componentDidMount() {
    //     window.history.go(-1);
    // }

    render() {
        return null;
    }
}

export default Reload;